import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  const { t } = useTranslation();

  const iconMap: Record<string, string> = {
    'celebrity-gossip': 'ri-star-line',
    'exclusive-scoop': 'ri-fire-line',
    'variety-hot': 'ri-tv-2-line',
    'film-tv-news': 'ri-film-line',
    'influencer-news': 'ri-live-line',
  };

  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            {t('categoryNav.title')}
            <span className="text-primary-500">{t('categoryNav.titleHighlight')}</span>
          </h2>
          <p className="text-foreground-500 text-sm mt-2">{t('categoryNav.subtitle')}</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-500/10 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${iconMap[cat.slug] || 'ri-folder-line'} text-2xl`}></i>
              </div>
              <span className="font-heading font-semibold text-foreground-800 text-sm md:text-base whitespace-nowrap group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
              <span className="text-foreground-400 text-xs text-center leading-relaxed hidden sm:block">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}